<template>
  <b-modal
    :id="ids"
    :ref="ids"
    header-bg-variant="primary"
    modal-class="mc-modal-report__filter"
    size="xl"
    centered
    scrollable
    static
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header>
      <h4 class="text-white">{{ $t('report.object.reportModal') }} - {{ name }}</h4>
    </template>
    <b-card class="mc-report__filter">
      <b-tabs>
        <b-tab :title="$t('global.object.data')" active>
          <div class="mc-report__filter-wrapper">
            <b-row>
              <b-col md="4">
                <h5 class="mc-report__filter-title mb-3">
                  {{ $t('report.object.columnData') }}
                </h5>
                <div
                  v-if="!fields.find((field) => field.key === 'timeBetweenGeofence')"
                  class="form-check d-flex justify-content-between mb-2"
                >
                  <b-form-checkbox
                    :id="`check-fleet-${ids}`"
                    v-model="isAllField"
                    :indeterminate="indeterminate"
                    name="all"
                    @input="checkAllFields"
                  >
                    {{ $t('global.action.selectAll') }}
                  </b-form-checkbox>
                </div>
                <div
                  v-for="field in fieldsTemp"
                  :key="field.key"
                  class="form-check d-flex justify-content-between mb-2"
                >
                  <b-form-checkbox
                    :id="`check-${field.key}-${ids}`"
                    v-model="selectedField[field.key]"
                    :disabled="field.disabled"
                    class="custom-disabled-checkbox checked"
                    :name="field.key"
                    checked
                  >
                    {{ field.label }}
                  </b-form-checkbox>
                  <b-button
                    v-if="field.filter"
                    size="sm"
                    variant="outline-primary"
                    @click="filterOpen = field.key"
                  >
                    <i class="mc-fa icon-outline_filter"></i> {{ $t('report.object.filter') }}
                  </b-button>
                </div>
              </b-col>
              <b-col md="8">
                <h5 class="mc-report__filter-title mb-3">
                  {{ $t('report.object.filter') }}
                </h5>
                <div v-if="!filterOpen" class="mc-report__filter-notfound">
                  <span>
                    <img :src="illustrationPath" alt />
                    <small>{{ $t('report.text.noFilter') }}</small>
                  </span>
                </div>
                <div v-if="filterOpen == 'vehicle'">
                  <b-row>
                    <b-col md="6">
                      <div
                        v-if="!isFilterSingle.vehicle"
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterVehicleSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterVehicleSelected.length }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('vehicle')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                      <div
                        v-else-if="fields.find((field) => field.key === 'timeBetweenGeofence')"
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterVehicleSelected" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterVehicleSelected.vehicleId ? '1' : '0'
                          }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('vehicle')">{{
                            $t('global.action.clear')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterVehicle"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllVehicle = false"
                        />
                      </label>
                    </b-col>
                  </b-row>

                  <div
                    v-if="
                      fields.find((field) => field.key === 'timeBetweenGeofence') ||
                      ids == 'bahan-bakar' ||
                      ids == 'temperatur'
                    "
                    class="table-responsive my-3 border border-1 mc-filter__table"
                  >
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="vehicleList"
                      :fields="fieldsVehicle"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterVehicle"
                      :filter-included-fields="['licensePlate', 'manufacturer', 'model', 'type']"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="!isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.id"
                            @input="checkVehicle"
                          />
                          <input
                            v-if="isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="{
                              vehicleId: data.item.id,
                              licensePlate: data.item.licensePlate,
                            }"
                            @input="checkVehicle"
                          />
                        </div>
                      </template>
                      <template #cell(vehicleTypeName)="data">
                        {{ data.item.manufacturer || '-' }} / {{ data.item.model || '-' }} /
                        {{ data.item.type || '-' }}
                      </template>
                      <template #cell(status)="data">
                        <span v-if="data.item.status === 'I'" class="mc-status mc-status--green">
                          {{ $t('master.status.aktif') }}
                        </span>
                        <span
                          v-else-if="data.item.status === 'R'"
                          class="mc-status mc-status--blue"
                        >
                          {{ $t('master.status.perbaikan') }}
                        </span>
                        <span v-else-if="data.item.status === 'A'" class="mc-status mc-status--red">
                          {{ $t('master.status.arsip') }}
                        </span>
                      </template>
                    </b-table>
                  </div>

                  <div
                    v-else-if="
                      ids == 'ringkasan-harian-kendaraan' ||
                      ids == 'riwayat-kendaraan' ||
                      ids == 'manajemen-kendaraan'
                    "
                    class="table-responsive my-3 border border-1 mc-filter__table"
                  >
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="vehicleList"
                      :fields="fieldsVehicleWithVGroups"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterVehicle"
                      :filter-included-fields="[
                        'licensePlate',
                        'manufacturer',
                        'model',
                        'type',
                        'vGroups',
                      ]"
                      @filtered="onFilteredVehicle"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-if="!isFilterSingle.vehicle"
                            v-model="selectAllVehicle"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllVehicle"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="!isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.id"
                            @input="checkVehicle"
                          />
                          <input
                            v-if="isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="data.item.id"
                            @input="checkVehicleSensor(data.item)"
                          />
                        </div>
                      </template>
                      <template #cell(vehicleTypeName)="data">
                        {{ data.item.manufacturer || '-' }} / {{ data.item.model || '-' }} /
                        {{ data.item.type || '-' }}
                      </template>
                      <template #cell(status)="data">
                        <span v-if="data.item.status === 'I'" class="mc-status mc-status--green">
                          {{ $t('master.status.aktif') }}
                        </span>
                        <span
                          v-else-if="data.item.status === 'R'"
                          class="mc-status mc-status--blue"
                        >
                          {{ $t('master.status.perbaikan') }}
                        </span>
                        <span v-else-if="data.item.status === 'A'" class="mc-status mc-status--red">
                          {{ $t('master.status.arsip') }}
                        </span>
                      </template>
                    </b-table>
                  </div>

                  <div v-else class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="vehicleList"
                      :fields="fieldsVehicle"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterVehicle"
                      :filter-included-fields="['licensePlate', 'manufacturer', 'model', 'type']"
                      @filtered="onFilteredVehicle"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-if="!isFilterSingle.vehicle"
                            v-model="selectAllVehicle"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllVehicle"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="!isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.id"
                            @input="checkVehicle"
                          />
                          <input
                            v-if="isFilterSingle.vehicle"
                            v-model="filterVehicleSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="data.item.id"
                            @input="checkVehicleSensor(data.item)"
                          />
                        </div>
                      </template>
                      <template #cell(vehicleTypeName)="data">
                        {{ data.item.manufacturer || '-' }} / {{ data.item.model || '-' }} /
                        {{ data.item.type || '-' }}
                      </template>
                      <template #cell(status)="data">
                        <span v-if="data.item.status === 'I'" class="mc-status mc-status--green">
                          {{ $t('master.status.aktif') }}
                        </span>
                        <span
                          v-else-if="data.item.status === 'R'"
                          class="mc-status mc-status--blue"
                        >
                          {{ $t('master.status.perbaikan') }}
                        </span>
                        <span v-else-if="data.item.status === 'A'" class="mc-status mc-status--red">
                          {{ $t('master.status.arsip') }}
                        </span>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'driver'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterDriverSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterDriverSelected.length }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('driver')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterDriver"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="employees.employees"
                      :fields="fieldsDriver"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterDriver"
                      :filter-included-fields="['fullname']"
                      @filtered="onFilteredDriver"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllDriver"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllDriver"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterDriverSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.userId"
                            @input="checkDriver"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'geofence'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGeofenceSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterGeofenceSelected.length }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('geofence')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                      <div
                        v-if="fields.find((field) => field.key === 'timeBetweenGeofence')"
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGeofenceSelected" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterGeofenceSelected.geofenceId ? '1' : '0'
                          }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('geofence')">{{
                            $t('global.action.clear')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterGeofence"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div
                    v-if="fields.find((field) => field.key === 'timeBetweenGeofence')"
                    class="table-responsive my-3 border border-1 mc-filter__table"
                  >
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="fieldsGarage"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofence"
                      :filter-included-fields="['fenceName']"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="isFilterSingle.geofence"
                            v-model="filterGeofenceSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="{
                              geofenceId: data.item.geofenceId,
                              garage: data.item.fenceName,
                            }"
                            @input="checkGeofence"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                  <div v-else class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="
                        fields.find((field) => field.header === 'intersectGeofences')
                          ? fieldsGeofenceIntersect
                          : fieldsGeofence
                      "
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofence"
                      :filter-included-fields="['fenceName']"
                      @filtered="onFilteredGeofence"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllGeofence"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllGeofence"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterGeofenceSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.geofenceId"
                            @input="checkGeofence"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'geofenceStart'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGeofenceStartSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterGeofenceStartSelected.length
                          }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('geofenceStart')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterGeofenceStart"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      ref="geofenceStartRef"
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="fieldsGeofenceStart"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofenceStart"
                      :filter-included-fields="['fenceName']"
                      @filtered="onFilteredGeofenceStart"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="isFilterSingle.geofenceStart"
                            v-model="filterGeofenceStartSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="{
                              geofenceId: data.item.geofenceId,
                              fenceName: data.item.fenceName,
                            }"
                            @input="checkGeofenceStart"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'geofenceStop'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-stop"
                      >
                        <h6 v-if="filterGeofenceStopSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterGeofenceStopSelected.length
                          }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('geofenceStop')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterGeofenceStop"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      ref="geofenceStopRef"
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="fieldsGeofenceStop"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofenceStop"
                      :filter-included-fields="['fenceName']"
                      @filtered="onFilteredGeofenceStop"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-if="isFilterSingle.geofenceStop"
                            v-model="filterGeofenceStopSelected"
                            class="form-check-input me-1"
                            type="radio"
                            :value="{
                              geofenceId: data.item.geofenceId,
                              fenceName: data.item.fenceName,
                            }"
                            @input="checkGeofenceStop"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'alert'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterAlertSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{
                            gpsSelected
                              ? filterAlertSelected.length - 1
                              : filterAlertSelected.length
                          }}</span>
                          {{ $t('global.object.selectedRow') }}
                          <a class="color-primary" @click="clearDelete('alert')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterAlert"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllAlert = false"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="hiddenAlert"
                      :fields="fieldsAlert"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      sort-by="descriptionIdn"
                      :filter="filterAlert"
                      :filter-included-fields="['descriptionIdn']"
                      @filtered="onFilteredAlert"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllAlert"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllAlert"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterAlertSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.alertCode"
                            @input="checkAlert"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'finalGrade'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGradeSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterGradeSelected.length }}</span>
                          {{ $t('global.selectedRows') }}.
                          <a class="color-primary" @click="clearDelete('grade')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterGrade"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllGrade = false"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="gradeIndex"
                      :fields="fieldsGrade"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGrade"
                      :filter-included-fields="['grade']"
                      @filtered="onFilteredGrade"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllGrade"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllGrade"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterGradeSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.grade"
                            @input="checkGrade"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'status'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterServiceStatusSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterServiceStatusSelected.length
                          }}</span>
                          {{ $t('global.selectedRows') }}.
                          <a class="color-primary" @click="clearDelete('grade')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterServiceStatus"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllServiceStatus = false"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="serviceStatus"
                      :fields="fieldsServiceStatus"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterServiceStatus"
                      :filter-included-fields="['grade']"
                      @filtered="onFilteredServiceStatus"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllServiceStatus"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllServiceStatus"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterServiceStatusSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.code"
                            @input="checkServiceStatus"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'acc'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterAccSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterAccSelected.length }}</span>
                          {{ $t('global.selectedRows') }}.
                          <a class="color-primary" @click="clearDelete('acc')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterAcc"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllAcc = false"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="accOptions"
                      :fields="fieldsAcc"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterAcc"
                      :filter-included-fields="['acc']"
                      @filtered="onFilteredAcc"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllAcc"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllAcc"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterAccSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.key"
                            @input="checkAcc"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'condition'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterConditionSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterConditionSelected.length
                          }}</span>
                          {{ $t('global.selectedRows') }}.
                          <a class="color-primary" @click="clearDelete('condition')">{{
                            $t('global.action.clearAll')
                          }}</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterCondition"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          @input="selectAllCondition = false"
                        />
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="conditionOptions"
                      :fields="fieldsCondition"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterCondition"
                      :filter-included-fields="['condition']"
                      @filtered="onFilteredCondition"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            v-model="selectAllCondition"
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            @input="toggleAllCondition"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            v-model="filterConditionSelected"
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.key"
                            @input="checkCondition"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab :title="$t('report.title.columnArrangement')">
          <div class="mc-report__filter-wrapper">
            <b-row class="py-3">
              <b-col>
                <i id="tool-table-layout" class="icon-outline_info float-end"></i>

                <b-tooltip
                  target="tool-table-layout"
                  triggers="click"
                  placement="lefttop"
                  class="text-start"
                >
                  &#9900; {{ $t('report.text.clickToChange') }}<br />
                  &#9900; {{ $t('report.text.clickAndHold') }}
                </b-tooltip>
              </b-col>
            </b-row>

            <draggable v-model="fieldsTemp" class="mc-report__filter-draggable-wrapper mb-3">
              <transition-group>
                <span v-for="row in fieldsTemp" :key="row.key" class="mc-report__filter-draggable">
                  <i class="icon-fill_move me-2"></i> {{ row.label }}
                </span>
              </transition-group>
            </draggable>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <template #modal-footer>
      <b-row class="mc-modal__filter-footer mc-modal__filter-footer--report">
        <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
          <b-row v-if="phaseOneShow">
            <b-col md="6">
              <b-form-group
                v-if="!isAddFavorit"
                id="favorit-label-modal"
                label="Favorit"
                label-for="favorit-modal"
              >
                <multiselect
                  v-model="fav"
                  :options="['Semua Model', 'Semua Kendaraan', 'Semua Wing']"
                  :show-labels="false"
                />
              </b-form-group>
              <b-form-group
                v-if="isAddFavorit"
                id="favorit-add-label-modal"
                label="Favorit"
                label-for="favorit-modal-add"
              >
                <b-form-input
                  id="favorit-modal-add"
                  v-model="addFavorit"
                  :placeholder="$t('report.object.favoriteName')"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-button
                v-if="!isAddFavorit"
                variant="outline-primary"
                class="mt-4"
                @click="isAddFavorit = !isAddFavorit"
              >
                <i class="mdi mdi-file-plus-outline"></i> {{ $t('report.action.newFavorite') }}
              </b-button>
              <b-button v-if="isAddFavorit" variant="outline-primary" class="mt-4">
                <i class="bx bxs-save"></i> {{ $t('report.action.saveFavorite') }}
              </b-button>
              <i
                v-if="isAddFavorit"
                class="bx bx-trash-alt text-danger text-lg mt-4 mx-2"
                @click="isAddFavorit = !isAddFavorit"
              ></i>
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" class="me-3" @click="cancelFilter()">
            {{ $t('global.action.cancel') }}
          </b-button>
          <b-button variant="primary" @click="applyFilter()">
            {{ $t('global.action.apply') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { GET_EMPLOYEES } from '@/services/api/master/employees'
import { GET_VEHICLE_FILTER_ALL } from '@/services/api/master/fleet'
import { GET_GEOFENCES } from '@/services/api/master/geofence'
import { NOTIFICATION_LIST_CODES } from '@/services/api/notification/general'
import draggable from 'vuedraggable'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable,
  },
  apollo: {
    employees: {
      query: GET_EMPLOYEES,
      variables() {
        return {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: JSON.stringify({ fullname: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        this.filteredDriver = [...data.employees.employees]
      },
    },
    vehicles: {
      query: GET_VEHICLE_FILTER_ALL,
      variables() {
        return {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: JSON.stringify({ licensePlate: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (loading) return

        let res = [...data.vehicles.vehicles]

        let temp = []
        res.forEach(function (item, index) {
          temp[index] = {
            id: item.id,
            licensePlate: item.licensePlate,
            manufacturer: item.vehicleType ? item.vehicleType.manufacturer : null,
            model: item.vehicleType ? item.vehicleType.model : null,
            type: item.vehicleType ? item.vehicleType.type : null,
            status: item.status,
            door1: item.door1,
            door2: item.door2,
            vGroups:
              item.vehicle2Vgroup && item.vehicle2Vgroup.length > 0
                ? item.vehicle2Vgroup.map((v) => v.vgroup.name).join(', ')
                : '-',
          }
        })

        this.vehicleList = temp
        this.filteredVehicle = temp
      },
    },
    geofences: {
      query: GET_GEOFENCES,
      variables() {
        return {
          filter: {
            orderBy: JSON.stringify({ fenceName: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.filteredGeofence = [...data.geofences.geofences.data]
        }
      },
    },
    alertCodes: {
      query: NOTIFICATION_LIST_CODES,
      variables() {
        let alertCodes = [
          12, 1, 10, 2, 11, 8, 4, 5, 19, 20, 13, 14, 15, 16, 21, 22, 23, 24, 25, 42, 43, 44, 45, 46,
          26, 75, 17, 18,
        ]
        if (this.hasAccess(['notif_tamper_alert:read'])) alertCodes.push(37)
        if (this.hasAccess(['seat_belt_alert:read'])) alertCodes.push(110)
        if (this.hasAccess(['e1g-web-adas:read'])) alertCodes = alertCodes.concat([90, 91, 92])
        if (this.hasAccess(['teltonika-device:read'])) alertCodes.push(94)
        if (this.hasAccess(['e1c-web-dms:read']))
          alertCodes = alertCodes.concat([51, 52, 53, 54, 55, 56])
        if (this.hasAccess(['e1c-web-dms:read']))
          alertCodes.push(49)
        if (this.hasAccess(['fatigue_driving_alert:read'])) alertCodes.push(50)
        if (this.hasAccess(['infrared_blocked_alert:read'])) alertCodes.push(111)
        if (this.hasAccess(['front_object_detected_alert:read'])) alertCodes.push(113)
        return {
          filter: {
            alertCode: alertCodes,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        const res = [...data.alertCodes.alertCodes]
        this.filteredAlert = res?.filter(
          (x) =>
            x.alertCode !== 42 &&
            x.alertCode !== 43 &&
            x.alertCode !== 44 &&
            x.alertCode !== 45 &&
            x.alertCode !== 46
        )
      },
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isFilterSingle: {
      type: Object,
      default: () => ({
        vehicle: false,
        driver: false,
        geofence: false,
      }),
    },
    ids: {
      type: String,
      required: false,
    },
    selected: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      indeterminate: false,
      phaseOneShow: false,
      input: [],
      listData: this.data,
      isAllField: true,
      selectedField: {},
      filterOpen: null,
      fieldOrder: [],
      filterVehicleSelected: [],
      filterDriverSelected: [],
      filterGeofenceSelected: [],
      filterGeofenceStartSelected: [],
      filterGeofenceStopSelected: [],
      filterAlertSelected: [],
      filterGradeSelected: [],
      filterServiceStatusSelected: [],
      filterAccSelected: [],
      filterConditionSelected: [],
      selectAllVehicle: false,
      selectAllDriver: false,
      selectAllGeofence: false,
      selectAllGeofenceStart: false,
      selectAllGeofenceStop: false,
      selectAllAlert: false,
      selectAllGrade: false,
      selectAllServiceStatus: false,
      selectAllAcc: false,
      selectAllCondition: false,
      tempVehicleSelected: [],
      tempDriverSelected: [],
      tempGeofenceSelected: [],
      tempGeofenceStartSelected: [],
      tempGeofenceStopSelected: [],
      tempAlertSelected: [],
      tempServiceStatusSelected: [],
      tempAccSelected: [],
      tempConditionSelected: [],
      filterVehicle: '',
      filterDriver: '',
      filterGeofence: '',
      filterGeofenceStart: '',
      filterGeofenceStop: '',
      filterAlert: '',
      filterGrade: '',
      filterServiceStatus: '',
      filterAcc: '',
      filterCondition: '',
      filteredVehicle: [],
      filteredDriver: [],
      filteredGeofence: [],
      filteredGeofenceStart: [],
      filteredGeofenceStop: [],
      filteredAlert: [],
      filteredGrade: [
        { id: 0, grade: 'A' },
        { id: 1, grade: 'B' },
        { id: 2, grade: 'C' },
        { id: 3, grade: 'D' },
        { id: 4, grade: 'E' },
      ],
      filteredServiceStatus: [
        {
          id: 0,
          code: 'normalDate',
        },
        { id: 1, code: 'inProgress' },
        {
          id: 2,
          code: 'lateDate',
        },
        {
          id: 3,
          code: 'soonDate',
        },
      ],
      filteredAcc: [
        { key: 'on', label: this.$t('report.label.on') },
        { key: 'off', label: this.$t('report.label.off') },
      ],
      filteredCondition: [
        { key: 'in', label: this.$t('report.label.in') },
        { key: 'out', label: this.$t('report.label.out') },
      ],
      employees: {
        employees: [],
      },
      vehicles: {
        vehicles: [],
      },
      geofences: {
        geofences: [],
      },
      alertCodes: {
        alertCodes: [],
      },
      gradeIndex: [
        { id: 0, grade: 'A' },
        { id: 1, grade: 'B' },
        { id: 2, grade: 'C' },
        { id: 3, grade: 'D' },
        { id: 4, grade: 'E' },
      ],
      accOptions: [
        { key: 'on', label: this.$t('report.label.on') },
        { key: 'off', label: this.$t('report.label.off') },
      ],
      conditionOptions: [
        { key: 'in', label: this.$t('report.label.in') },
        { key: 'out', label: this.$t('report.label.out') },
      ],
      vehicleList: [],
      gpsSelected: false,
      fieldsTemp: [],
      alertsDMS: [49, 51, 52, 53, 54, 55, 56, 110, 111, 50],
      alertsADAS: [90, 91, 92, 113],
    }
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
      isMetrack: 'identity/isMetrack',
    }),
    hiddenAlert() {
      let alertCodes = [...this.alertCodes.alertCodes]

      return alertCodes?.filter(
        (x) =>
          x.alertCode != 37 &&
          x.alertCode != 42 &&
          x.alertCode != 43 &&
          x.alertCode != 44 &&
          x.alertCode != 45 &&
          x.alertCode != 46
      )
    },

    fieldsDriver() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fullname',
          label: this.$t('report.fields.driver'),
          sortable: false,
        },
      ]
    },

    fieldsVehicle() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'licensePlate',
          label: this.$t('report.fields.licensePlate'),
          sortable: false,
        },
        {
          key: 'vehicleTypeName',
          label: this.$t('report.fields.vehicleType'),
          sortable: false,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
        },
      ]
    },

    fieldsVehicleWithVGroups() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'licensePlate',
          label: this.$t('report.fields.licensePlate'),
          sortable: false,
        },
        {
          key: 'vehicleTypeName',
          label: this.$t('report.fields.vehicleType'),
          sortable: false,
        },
        {
          key: 'vGroups',
          label: this.$t('report.fields.vehicleGroup'),
          sortable: false,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
        },
      ]
    },

    fieldsGeofence() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: this.$t('report.report.geofence'),
          sortable: false,
        },
      ]
    },
    fieldsGeofenceStart() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: this.$t('report.fields.startGeofence'),
          sortable: false,
        },
      ]
    },
    fieldsGeofenceStop() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: this.$t('report.fields.stopGeofence'),
          sortable: false,
        },
      ]
    },
    fieldsGeofenceIntersect() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: this.$t('report.fields.passedGeofence'),
          sortable: false,
        },
      ]
    },

    fieldsGarage() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: this.$t('report.fields.garage'),
          sortable: false,
        },
      ]
    },

    fieldsAlert() {
      let lang = localStorage.getItem('language')
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: lang === 'en' ? 'descriptionEng' : 'descriptionIdn',
          label: this.$t('report.fields.alertType'),
          sortable: false,
        },
      ]
    },

    fieldsGrade() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'grade',
          label: this.$t('global.object.index'),
          sortable: false,
        },
      ]
    },

    fieldsServiceStatus() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'status',
          label: this.$t('maintenance.field.statusService'),
          sortable: false,
        },
      ]
    },

    serviceStatus() {
      return [
        {
          id: 0,
          code: 'normalDate',
          status: this.$t('maintenance.status.normal'),
        },
        { id: 1, code: 'inProgress', status: this.$t('maintenance.status.inService') },
        {
          id: 2,
          code: 'lateDate',
          status: this.$t('maintenance.status.lateService'),
        },
        {
          id: 3,
          code: 'soonDate',
          status: this.$t('maintenance.status.approachingService'),
        },
      ]
    },

    fieldsAcc() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'label',
          label: this.$t('report.object.acc'),
          sortable: false,
        },
      ]
    },

    fieldsCondition() {
      return [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'label',
          label: this.$t('report.object.condition'),
          sortable: false,
        },
      ]
    },

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-filter.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-filter.svg`)
    },

    countAlertSelected() {
      let count = 0
      this.filterAlertSelected.forEach((item) => {
        if (item != 37) count++
      })
      return count
    },
  },
  watch: {
    immediate: true,
    selectedField: {
      handler(newval) {
        let count = 0
        let checkedTotal = Object.keys(this.selectedField).length
        Object.values(newval).forEach((val) => {
          if (val === true) {
            count = count + 1
          }
        })
        if (count === checkedTotal) {
          this.indeterminate = false
          this.isAllField = true
        } else if (count === 0) {
          this.indeterminate = true
          this.isAllField = false
        } else {
          this.indeterminate = true
        }
      },
      deep: true,
    },
  },
  mounted() {
    let selectedDefault = {}

    let toSelect = this.fields

    if (this.selected) {
      toSelect = this.selected.fields
      this.tempVehicleSelected = this.filterVehicleSelected = this.selected.filterVehicle
        ? this.selected.filterVehicle
        : []
      this.tempDriverSelected = this.filterDriverSelected = this.selected.filterDriver
        ? this.selected.filterDriver
        : []
      this.tempAlertSelected = this.filterAlertSelected = this.selected.filterAlert
        ? this.selected.filterAlert
        : []

      this.selectAllVehicle = this.filterVehicleSelected.length == this.filteredVehicle.length
      this.selectAllDriver = this.filterDriverSelected.length == this.filteredDriver.length
      this.selectAllAlert = this.filterAlertSelected.length == this.filteredAlert.length
      this.selectAllServiceStatus =
        this.filterServiceStatusSelected.length == this.filteredServiceStatus.length
      this.selectAllAcc = this.filterAccSelected.length == this.filteredAcc.length
      this.selectAllCondition = this.filterConditionSelected.length == this.filteredCondition.length
    }

    toSelect.forEach(function (item) {
      selectedDefault[item.key] = true
    })

    this.selectedField = selectedDefault

    this.fieldsTemp = this.fields

    this.$apollo.queries.vehicles.refetch({
      filter: {
        orderBy: JSON.stringify({ licensePlate: 'asc' }),
        status: ['I', 'R', 'A'],
        isHaveSensorTemperature: this.ids == 'temperatur' ? true : undefined,
        isHaveSensorFuel:
          this.ids == 'bahan-bakar' ||
          this.ids == 'ringkasan-bahan-bakar' ||
          this.ids == 'ringkasan-harian-bahan-bakar'
            ? true
            : undefined,
        isHaveSensorDoor1: this.ids == 'pintu' ? true : undefined,
        isHaveSensorDoor2: this.ids == 'pintu' ? true : undefined,
      },
    })
  },
  methods: {
    applyFilter() {
      if (this.ids == 'peringatan' && this.countAlertSelected > 1) {
        if (this.filterVehicleSelected.length > 20) {
          return Swal.fire({
            title: this.$t('report.text.previewFailed'),
            text: this.$t('report.text.vehicleAlertSwal'),
            imageUrl: require(`@/assets/images/alert-report-danger.png`),
            confirmButtonText: this.$t('global.action.close'),
          })
        }
      } else if (
        this.name == 'Detail Riwayat Kendaraan' &&
        this.filterVehicleSelected.length == 0
      ) {
        return Swal.fire({
          title: 'Gagal Pratinjau',
          text: 'Anda diharuskan memilih satu Plat Nomor pada Model Laporan',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          confirmButtonText: 'Tutup',
        })
      }
      if (this.isFilterSingle.vehicle) this.tempVehicleSelected = this.filterVehicleSelected
      else this.tempVehicleSelected = [...this.filterVehicleSelected]

      if (this.isFilterSingle.geofence) this.tempGeofenceSelected = this.filterGeofenceSelected
      else {
        if (this.fields.find((field) => field.header === 'intersectGeofences')) {
          const selectedFilters = [...this.filterGeofenceSelected]

          let selectedData = []
          for (let i = 0; i < selectedFilters.length; i++) {
            const data = this.filteredGeofence.filter(
              (item) => item.geofenceId === selectedFilters[i]
            )
            selectedData.push(data[0])
          }
          this.tempGeofenceSelected = [...selectedData]
        } else {
          this.tempGeofenceSelected = [...this.filterGeofenceSelected]
        }
      }

      if (this.isFilterSingle.geofenceStart)
        this.tempGeofenceStartSelected = this.filterGeofenceStartSelected
      else this.tempGeofenceStartSelected = [...this.filterGeofenceStartSelected]

      if (this.isFilterSingle.geofenceStop)
        this.tempGeofenceStopSelected = this.filterGeofenceStopSelected
      else this.tempGeofenceStopSelected = [...this.filterGeofenceStopSelected]

      this.tempDriverSelected = [...this.filterDriverSelected]
      this.tempAlertSelected = [...this.filterAlertSelected]

      let allFilter = {
        fields: this.getSelectedFields(),
        filterDriver: this.tempDriverSelected,
        filterVehicle: this.tempVehicleSelected,
        filterGeofence: this.tempGeofenceSelected,
        filterGeofenceStart: this.tempGeofenceStartSelected,
        filterGeofenceStop: this.tempGeofenceStopSelected,
        filterAlert: this.tempAlertSelected,
        filterGrade: this.filterGradeSelected,
        filterServiceStatus: this.filterServiceStatusSelected,
        filterAcc: this.filterAccSelected,
        filterCondition: this.filterConditionSelected,
      }

      this.$emit('input', allFilter)
      this.$bvModal.hide(this.ids)
    },

    cancelFilter() {
      this.$bvModal.hide(this.ids)
      this.filterVehicleSelected = this.isFilterSingle.vehicle
        ? this.tempVehicleSelected
        : [...this.tempVehicleSelected]

      this.filterGeofenceSelected = this.isFilterSingle.geofence
        ? this.tempGeofenceSelected
        : [...this.tempGeofenceSelected]

      this.filterGeofenceStartSelected = this.isFilterSingle.geofenceStart
        ? this.tempGeofenceStartSelected
        : [...this.tempGeofenceStartSelected]

      this.filterGeofenceStopSelected = this.isFilterSingle.geofenceStop
        ? this.tempGeofenceStopSelected
        : [...this.tempGeofenceStopSelected]

      this.filterDriverSelected = [...this.tempDriverSelected]
      this.filterAlertSelected = [...this.tempAlertSelected]
      this.filterServiceStatusSelected = [...this.tempServiceStatusSelected]

      this.selectAllVehicle = this.isFilterSingle.vehicle
        ? false
        : this.filteredVehicle.every((iterator) => this.filterVehicleSelected.includes(iterator.id))

      this.selectAllGeofence = this.isFilterSingle.geofence
        ? false
        : this.filteredGeofence.every((iterator) =>
            this.filterGeofenceSelected.includes(iterator.geofenceId)
          )

      this.selectAllGeofenceStart = this.isFilterSingle.geofenceStart
        ? false
        : this.filteredGeofenceStart.every((iterator) =>
            this.filterGeofenceStartSelected.includes(iterator.geofenceId)
          )

      this.selectAllGeofenceStop = this.isFilterSingle.geofenceStop
        ? false
        : this.filteredGeofenceStop.every((iterator) =>
            this.filterGeofenceStopSelected.includes(iterator.geofenceId)
          )

      this.selectAllDriver = this.filteredDriver.every((iterator) =>
        this.filterDriverSelected.includes(iterator.userId)
      )

      this.selectAllAlert = this.filteredAlert.every((iterator) =>
        this.filterAlertSelected.includes(iterator.alertCode)
      )

      this.selectAllGrade = this.filteredGrade.every((iterator) =>
        this.filterGradeSelected.includes(iterator.grade)
      )

      this.selectAllServiceStatus = this.filteredServiceStatus.every((iterator) =>
        this.filterServiceStatusSelected.includes(iterator.code)
      )

      this.selectAllAcc = this.filteredAcc.every((iterator) =>
        this.filterAccSelected.includes(iterator.label)
      )

      this.selectAllCondition = this.filteredCondition.every((iterator) =>
        this.filterConditionSelected.includes(iterator.label)
      )
    },

    getSelectedFields() {
      let fieldsCheck = []
      let selected = this.selectedField
      Object.keys(this.selectedField).forEach(function (key) {
        if (key != 'all') {
          if (selected[key] === true) {
            fieldsCheck.push(key)
          }
        }
      })

      let fieldFilter = this.fieldsTemp.filter(function (item) {
        return fieldsCheck.includes(item.key)
      })
      return fieldFilter
    },

    checkAllFields(value) {
      let self = this
      this.fields.forEach(function (item) {
        if (!item.disabled) {
          self.selectedField[item.key] = value
        }
      })
    },

    checkVehicle(event) {
      const vehicleId = parseInt(event.target.value)

      if (event.target.checked) {
        if (this.isFilterSingle.vehicle) {
          this.filterVehicleSelected = vehicleId
        } else {
          this.filterVehicleSelected.push(vehicleId)
          const allSelected = this.filteredVehicle.every((iterator) => {
            this.filterVehicleSelected.includes(iterator.id)
          })
          this.selectAllVehicle = allSelected
        }
      } else {
        this.selectAllVehicle = false
        const index = this.filterVehicleSelected.indexOf(vehicleId)
        if (index !== -1) {
          this.filterVehicleSelected.splice(index, 1)
        }
      }
    },

    checkDriver(event) {
      const driverId = parseInt(event.target.value)

      if (event.target.checked) {
        this.filterDriverSelected.push(driverId)
        const allSelected = this.filteredDriver.every((iterator) =>
          this.filterDriverSelected.includes(iterator.userId)
        )
        this.selectAllDriver = allSelected
      } else {
        this.selectAllDriver = false
        const index = this.filterDriverSelected.indexOf(driverId)
        if (index !== -1) {
          this.filterDriverSelected.splice(index, 1)
        }
      }
    },

    checkGeofence(event) {
      const geofenceId = parseInt(event.target.value)

      if (event.target.checked) {
        if (this.isFilterSingle.geofence) {
          this.filterGeofenceSelected = geofenceId
        } else {
          this.filterGeofenceSelected.push(geofenceId)
          const allSelected = this.filteredGeofence.every((iterator) =>
            this.filterGeofenceSelected.includes(iterator.geofenceId)
          )
          this.selectAllGeofence = allSelected
        }
      } else {
        this.selectAllGeofence = false
        const index = this.filterGeofenceSelected.indexOf(geofenceId)
        if (index !== -1) {
          this.filterGeofenceSelected.splice(index, 1)
        }
      }
    },

    checkGeofenceStart(event) {
      const geofenceId = parseInt(event.target.value)

      if (event.target.checked) {
        if (this.isFilterSingle.geofenceStart) {
          this.filterGeofenceStartSelected = geofenceId
        } else {
          this.filterGeofenceStartSelected.push(geofenceId)
          const allSelected = this.filteredGeofenceStart.every((iterator) => {
            this.filterGeofenceStartSelected.includes(iterator.geofenceId)
          })
          this.selectAllGeofenceStart = allSelected
        }
      } else {
        this.selectAllGeofenceStart = false
        const index = this.filterGeofenceStartSelected.indexOf(geofenceId)
        if (index !== -1) {
          this.filterGeofenceStartSelected.splice(index, 1)
        }
      }
    },

    checkGeofenceStop(event) {
      const geofenceId = parseInt(event.target.value)

      if (event.target.checked) {
        if (this.isFilterSingle.geofenceStop) {
          this.filterGeofenceStopSelected = geofenceId
        } else {
          this.filterGeofenceStopSelected.push(geofenceId)
          const allSelected = this.filteredGeofenceStop.every((iterator) => {
            this.filterGeofenceStopSelected.includes(iterator.geofenceId)
          })
          this.selectAllGeofenceStop = allSelected
        }
      } else {
        this.selectAllGeofenceStop = false
        const index = this.filterGeofenceStopSelected.indexOf(geofenceId)
        if (index !== -1) {
          this.filterGeofenceStopSelected.splice(index, 1)
        }
      }
    },

    checkAlert(event) {
      const alertCode = parseInt(event.target.value)
      if (event.target.checked) {
        if (alertCode == 1 && this.hasAccess(['notif_tamper_alert:read'])) {
          this.filterAlertSelected.push(37)
          this.gpsSelected = true
        }
        this.filterAlertSelected.push(alertCode)
        const allSelected = this.filteredAlert.every((iterator) =>
          this.filterAlertSelected.includes(iterator.alertCode)
        )
        this.selectAllAlert = allSelected
        this.filterColumns()
      } else {
        this.selectAllAlert = false
        const index = this.filterAlertSelected.indexOf(alertCode)
        if (index !== -1) {
          this.filterAlertSelected.splice(index, 1)
        }
        if (alertCode == 1 && this.hasAccess(['notif_tamper_alert:read'])) {
          this.gpsSelected = false
          const index = this.filterAlertSelected.indexOf(37)
          if (index !== -1) {
            this.filterAlertSelected.splice(index, 1)
          }
        }
        this.filterColumns()
      }
    },

    checkGrade(event) {
      const gradeValue = event.target.value

      if (event.target.checked) {
        this.filterGradeSelected.push(gradeValue)
        const allSelected = this.filteredGrade.every((iterator) =>
          this.filterGradeSelected.includes(iterator.grade)
        )
        this.selectAllGrade = allSelected
      } else {
        this.selectAllGrade = false
        const index = this.filterGradeSelected.indexOf(gradeValue)
        if (index !== -1) {
          this.filterGradeSelected.splice(index, 1)
        }
      }
    },

    checkServiceStatus(event) {
      const statusValue = event.target.value

      if (event.target.checked) {
        this.filterServiceStatusSelected.push(statusValue)
        const allSelected = this.filteredServiceStatus.every((iterator) => {
          this.filterServiceStatusSelected.includes(iterator.code)
        })
        this.selectAllServiceStatus = allSelected
      } else {
        this.selectAllServiceStatus = false
        const index = this.filterServiceStatusSelected.indexOf(statusValue)
        if (index !== -1) {
          this.filterServiceStatusSelected.splice(index, 1)
        }
      }
    },

    checkAcc(event) {
      const accValue = event.target.value

      if (event.target.checked) {
        this.filterAccSelected.push(accValue)
        const allSelected = this.filteredAcc.every((iterator) =>
          this.filterAccSelected.includes(iterator.key)
        )
        this.selectAllAcc = allSelected
      } else {
        this.selectAllAcc = false
        const index = this.filterAccSelected.indexOf(accValue)
        if (index !== -1) {
          this.filterAccSelected.splice(index, 1)
        }
      }
    },

    checkCondition(event) {
      const conditionValue = event.target.value

      if (event.target.checked) {
        this.filterConditionSelected.push(conditionValue)
        const allSelected = this.filteredCondition.every((iterator) =>
          this.filterConditionSelected.includes(iterator.key)
        )
        this.selectAllCondition = allSelected
      } else {
        this.selectAllCondition = false
        const index = this.filterConditionSelected.indexOf(conditionValue)
        if (index !== -1) {
          this.filterConditionSelected.splice(index, 1)
        }
      }
    },

    toggleAllVehicle(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredVehicle) {
          this.filterVehicleSelected.push(iterator.id)
        }
        this.filterVehicleSelected = [...new Set(this.filterVehicleSelected)]
      } else {
        for (const iterator of this.filteredVehicle) {
          let index = this.filterVehicleSelected.indexOf(iterator.id)
          if (index !== -1) {
            this.filterVehicleSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllDriver(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredDriver) {
          this.filterDriverSelected.push(iterator.userId)
        }
        this.filterDriverSelected = [...new Set(this.filterDriverSelected)]
      } else {
        for (const iterator of this.filteredDriver) {
          let index = this.filterDriverSelected.indexOf(iterator.userId)
          if (index !== -1) {
            this.filterDriverSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllGeofence(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredGeofence) {
          this.filterGeofenceSelected.push(iterator.geofenceId)
        }
        this.filterGeofenceSelected = [...new Set(this.filterGeofenceSelected)]
      } else {
        for (const iterator of this.filteredGeofence) {
          let index = this.filterGeofenceSelected.indexOf(iterator.geofenceId)
          if (index !== -1) {
            this.filterGeofenceSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllGeofenceStart(checked) {
      if (checked) {
        for (const iterator of this.filteredGeofenceStart) {
          this.filterGeofenceStartSelected.push(iterator.geofenceId)
        }
        this.filterGeofenceStartSelected = [...new Set(this.filterGeofenceStartSelected)]
      } else {
        for (const iterator of this.filteredGeofenceStart) {
          let index = this.filterGeofenceStartSelected.indexOf(iterator.geofenceId)
          if (index !== -1) {
            this.filterGeofenceStartSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllGeofenceStop(checked) {
      if (checked) {
        for (const iterator of this.filteredGeofenceStop) {
          this.filterGeofenceStopSelected.push(iterator.geofenceId)
        }
        this.filterGeofenceStopSelected = [...new Set(this.filterGeofenceStopSelected)]
      } else {
        for (const iterator of this.filteredGeofenceStop) {
          let index = this.filterGeofenceStopSelected.indexOf(iterator.geofenceId)
          if (index !== -1) {
            this.filterGeofenceStopSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllAlert(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredAlert) {
          this.filterAlertSelected.push(iterator.alertCode)
        }
        if (this.hasAccess(['notif_tamper_alert:read'])) {
          this.gpsSelected = true
          this.filterAlertSelected.push(37)
        }
        this.filterAlertSelected = [...new Set(this.filterAlertSelected)]
        this.filterColumns()
      } else {
        for (const iterator of this.filteredAlert) {
          let index = this.filterAlertSelected.indexOf(iterator.alertCode)
          if (index !== -1) {
            this.filterAlertSelected.splice(index, 1)
          }
        }
        if (this.hasAccess(['notif_tamper_alert:read'])) {
          this.gpsSelected = false
          const index = this.filterAlertSelected.indexOf(37)
          if (index !== -1) {
            this.filterAlertSelected.splice(index, 1)
          }
        }
        this.filterColumns()
      }
    },

    toggleAllGrade(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredGrade) {
          this.filterGradeSelected.push(iterator.grade)
        }
        this.filterGradeSelected = [...new Set(this.filterGradeSelected)]
      } else {
        for (const iterator of this.filteredGrade) {
          let index = this.filterGradeSelected.indexOf(iterator.grade)
          if (index !== -1) {
            this.filterGradeSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllServiceStatus(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredServiceStatus) {
          this.filterServiceStatusSelected.push(iterator.code)
        }
        this.filterServiceStatusSelected = [...new Set(this.filterServiceStatusSelected)]
      } else {
        for (const iterator of this.filteredServiceStatus) {
          let index = this.filterServiceStatusSelected.indexOf(iterator.code)
          if (index !== -1) {
            this.filterServiceStatusSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllAcc(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredAcc) {
          this.filterAccSelected.push(iterator.key)
        }
        this.filterAccSelected = [...new Set(this.filterAccSelected)]
      } else {
        for (const iterator of this.filteredAcc) {
          let index = this.filterAccSelected.indexOf(iterator.key)
          if (index !== -1) {
            this.filterAccSelected.splice(index, 1)
          }
        }
      }
    },

    toggleAllCondition(event) {
      let checked = event.target.checked

      if (checked) {
        for (const iterator of this.filteredCondition) {
          this.filterConditionSelected.push(iterator.key)
        }
        this.filterConditionSelected = [...new Set(this.filterConditionSelected)]
      } else {
        for (const iterator of this.filteredCondition) {
          let index = this.filterConditionSelected.indexOf(iterator.key)
          if (index !== -1) {
            this.filterConditionSelected.splice(index, 1)
          }
        }
      }
    },

    onFilteredVehicle(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredVehicle = filteredItems
    },

    onFilteredDriver(filteredItems) {
      this.filteredDriver = filteredItems
    },

    onFilteredGeofence(filteredItems) {
      this.filteredGeofence = filteredItems
    },

    onFilteredGeofenceStart(filteredItems) {
      this.filteredGeofenceStart = filteredItems
    },

    onFilteredGeofenceStop(filteredItems) {
      this.filteredGeofenceStop = filteredItems
    },

    onFilteredAlert(filteredItems) {
      this.filteredAlert = filteredItems
    },

    onFilteredGrade(filteredItems) {
      this.filteredGrade = filteredItems
    },

    onFilteredServiceStatus(filteredItems) {
      this.filteredServiceStatus = filteredItems
    },

    onFilteredAcc(filteredItems) {
      this.filteredAcc = filteredItems
    },

    onFilteredCondition(filteredItems) {
      this.filteredCondition = filteredItems
    },

    clearDelete(field) {
      if (field == 'driver') {
        this.filterDriverSelected = []
        this.selectAllDriver = false
      } else if (field == 'vehicle') {
        this.filterVehicleSelected = []
        this.selectAllVehicle = false
      } else if (field == 'geofence') {
        this.filterGeofenceSelected = []
        this.selectAllGeofence = false
      } else if (field == 'geofenceStart') {
        this.filterGeofenceStartSelected = []
        this.selectAllGeofenceStart = false
      } else if (field == 'geofenceStop') {
        this.filterGeofenceStopSelected = []
        this.selectAllGeofenceStop = false
      } else if (field == 'alert') {
        this.filterAlertSelected = []
        this.selectAllAlert = false
      } else if (field == 'grade') {
        this.filterGradeSelected = []
        this.selectAllGrade = false
      } else if (field == 'service') {
        this.filterServiceStatusSelected = []
        this.selectAllServiceStatus = false
      } else if (field == 'acc') {
        this.filterAccSelected = []
        this.selectAllAcc = false
      } else if (field == 'condition') {
        this.filterConditionSelected = []
        this.selectAllCondition = false
      }
    },

    checkVehicleSensor(data) {
      if (this.ids != 'temperatur') return

      let indexDoor1 = this.fieldsTemp.findIndex((item) => {
        return item.key == 'door1'
      })

      if (indexDoor1 < 0) return

      this.fieldsTemp[indexDoor1].disabled = !data.door1
      this.selectedField.door1 = data.door1

      let indexDoor2 = this.fieldsTemp.findIndex((item) => {
        return item.key == 'door2'
      })

      if (indexDoor2 < 0) return

      this.fieldsTemp[indexDoor2].disabled = !data.door2
      this.selectedField.door2 = data.door2
    },

    checkVehicleInTW(event) {
      if (event.target.checked) {
        this.filterVehicleSelected.push(parseInt(event.target.value))
        if (this.filterVehicleSelected.length == this.vehicles.vehicles.length) {
          this.selectAllVehicle = true
        }
      } else {
        this.selectAllVehicle = false
        let index = this.filterVehicleSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterVehicleSelected.splice(index, 1)
        }
      }
    },

    filterColumns() {
      let column = this.fields
      const hasDMSorADASAlert = this.filterAlertSelected.some(
        (code) => this.alertsDMS.includes(Number(code)) || this.alertsADAS.includes(Number(code))
      )
      if (!hasDMSorADASAlert) {
        column = column.filter((item) => item.key !== 'downloadVideo')
      }
      this.fieldsTemp = column
    },
  },
}
</script>
